
import Vue from 'vue'
export default Vue.extend({
  props: {
    title: {
      type: String,
      required: false
    },
    description: {
      type: String,
      required: false
    },
    url: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      navigator: navigator
    }
  },
  methods: {
    isShareCancelledError(err: Error) {
      const err_msg = ''+err;
      return err instanceof DOMException && (
        err_msg.indexOf('Share canceled') !== -1
        || err_msg.indexOf('Share cancelled') !== -1
      ) || err_msg.includes('AbortError');
    }
  }
})
